import { AxiosError, isAxiosError } from 'axios'

/** Auth-definitive refresh failures — safe to clear session / redirect to login. */
export function isHardRefreshFailure(error: unknown): boolean {
  if (!isAxiosError(error)) {
    return false
  }

  const status = error.response?.status
  return status === 401 || status === 419 || status === 422
}

/** Network / gateway / rate-limit — keep access token; retry on next tick. */
export function isTransientRefreshFailure(error: unknown): boolean {
  if (isHardRefreshFailure(error)) {
    return false
  }

  if (isAxiosError(error)) {
    if (!error.response) {
      return true
    }
    const status = error.response.status
    return status === 408 || status === 429 || status >= 500
  }

  if (error instanceof AxiosError) {
    return !error.response
  }

  if (error instanceof Error) {
    const msg = error.message.toLowerCase()
    return (
      msg.includes('network')
      || msg.includes('timeout')
      || msg.includes('abort')
      || msg.includes('offline')
      || msg.includes('refresh lock')
    )
  }

  return true
}
